import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { DrilldownJsonApiResponse } from 'api/normalized/insightDrilldown/InsightDrilldownApi';
import { transformUserDrilldownData } from 'api/normalized/insightDrilldown/transformers';
import { RootState } from 'state/store';
import { UserDrillDownItem } from 'types/store/normalized/insightsDrillDown';
import { JsonApiResource } from 'types/store/jsonApi';
import { UserDrillDownApiResponse } from 'api/normalized/insightDrilldown/types';

/* ============================== STATE SETUP =============================== */
const insightDrilldownUsersAdapter = createEntityAdapter<UserDrillDownItem>();

/* ================================= REDUCER ================================ */
const insightDrilldownUsersSlice = createSlice({
  name: 'normalized/insightDrilldownUsers',
  initialState: insightDrilldownUsersAdapter.getInitialState(),
  reducers: {
    addUsers: (
      state,
      action: PayloadAction<DrilldownJsonApiResponse['data']>
    ) => {
      const userDrilldowns = transformUserDrilldownData(
        action.payload as JsonApiResource<UserDrillDownApiResponse>[]
      );
      insightDrilldownUsersAdapter.setMany(state, userDrilldowns);
    },
  },
});

/* =============================== SELECTORS ================================ */
const defaultSelectors = insightDrilldownUsersAdapter.getSelectors<RootState>(
  (state) => state.normalized.insightDrilldownUsers
);

const selectUsersByIds = (
  state: RootState,
  ids: string[]
): UserDrillDownItem[] =>
  ids
    .map((id) => defaultSelectors.selectById(state, id))
    .filter((item) => !!item);

/* ================================ EXPORTS ================================= */
export const insightDrilldownUsersSelectors = {
  ...defaultSelectors,
  selectUsersByIds,
};
export const { addUsers } = insightDrilldownUsersSlice.actions;
export default insightDrilldownUsersSlice.reducer;
